import ChevronUpDownIcon from '@repo/ui/src/components/Icons/ChevronUpDownIcon';
import { classNames } from '../../utils/classNames';
import { formatTime, generateTimeOptions, parseTime } from './_buildSchedule';
import { PickerSection } from './_PickerSection';
import type { ServeTimeConfig } from './types';

interface TimePickerProps {
  config: ServeTimeConfig;
  value: string;
  onChange: (time: string) => void;
  theme: 'dark' | 'light';
}

export function TimePicker({ config, value, onChange, theme }: TimePickerProps) {
  const isDark = theme === 'dark';
  const step = config.stepMinutes ?? 30;
  const options = generateTimeOptions(step, config.minTime, config.maxTime);

  return (
    <PickerSection label={config.sectionLabel ?? 'Dinner time'} theme={theme}>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={classNames(
            'w-full appearance-none border px-4 py-3 text-lg font-medium',
            isDark
              ? 'border-neutral-300 bg-neutral-500 text-white print:border-transparent-light-200 print:bg-white print:text-neutral-900'
              : 'border-transparent-light-200 bg-white text-neutral-900',
          )}
          aria-label={config.sectionLabel ?? 'Dinner time'}
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {formatTime(parseTime(opt))}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 flex items-center pointer-events-none right-3">
          <ChevronUpDownIcon
            className="w-5 h-5"
            color={isDark ? 'var(--tra-color-neutral-100)' : 'var(--tra-color-neutral-500)'}
          />
        </div>
      </div>
    </PickerSection>
  );
}
